import {APIRequest} from "../APIRequest.js";
import {getVPCService, parkedDomain} from "../../App/utils";

export const API_URL = getVPCService('stripe-checkout') || "https://openkbs.stripe-checkout.vpc1.us/";

const timeout = 10000;


export const createStripeCheckout = async (depositAmount, userProfile, serviceId = 'credits') => {
    const token = localStorage.getItem("clientJWT");

    const queryParams = new URLSearchParams(window.location.search);
    // Add domain parameter if parkedDomain exists
    if (parkedDomain) {
        queryParams.set('domain', parkedDomain);
    }
    const fullApiUrl = `${API_URL}?${queryParams.toString()}`;

    // Check if generateInvoice is in URL params (for manual invoice generation in test mode)
    const generateInvoice = queryParams.get('generateInvoice');

    try {
        const response = await APIRequest('post', fullApiUrl, {
            token,
            country: userProfile?.country,
            amountInCents: Math.round(depositAmount * 100),
            serviceId,
            ...(generateInvoice ? { generateInvoice } : {})
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const refund = async (paymentIntentId, reason, customerReason) => {
    const token = localStorage.getItem("clientJWT");

    const queryParams = new URLSearchParams(window.location.search);
    // Add domain parameter if parkedDomain exists
    if (parkedDomain) {
        queryParams.set('domain', parkedDomain);
    }
    const fullApiUrl = `${API_URL}?${queryParams.toString()}`;

    try {
        const response = await APIRequest('post', fullApiUrl, {
            action: 'refund',
            token,
            paymentIntentId,
            customerReason,
            reason
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const createSubscription = async (planId, userProfile, variantId = null) => {
    const token = localStorage.getItem("clientJWT");

    const queryParams = new URLSearchParams(window.location.search);
    // Add domain parameter if parkedDomain exists
    if (parkedDomain) {
        queryParams.set('domain', parkedDomain);
    }
    const fullApiUrl = `${API_URL}?${queryParams.toString()}`;

    // Check for variant in URL params if not explicitly passed
    const urlVariant = queryParams.get('variant');
    const effectiveVariantId = variantId || urlVariant;

    try {
        const response = await APIRequest('post', fullApiUrl, {
            action: 'createSubscription',
            token,
            planId,
            ...(effectiveVariantId ? { variantId: effectiveVariantId } : {}),
            country: userProfile?.country
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const cancelSubscription = async (subscriptionId) => {
    const token = localStorage.getItem("clientJWT");

    const queryParams = new URLSearchParams(window.location.search);
    // Add domain parameter if parkedDomain exists
    if (parkedDomain) {
        queryParams.set('domain', parkedDomain);
    }
    const fullApiUrl = `${API_URL}?${queryParams.toString()}`;

    try {
        const response = await APIRequest('post', fullApiUrl, {
            action: 'cancelSubscription',
            token,
            subscriptionId
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

// updateSubscription removed - users should cancel and resubscribe to change plans

export const getSubscription = async () => {
    const token = localStorage.getItem("clientJWT");

    const queryParams = new URLSearchParams(window.location.search);
    // Add domain parameter if parkedDomain exists
    if (parkedDomain) {
        queryParams.set('domain', parkedDomain);
    }
    const fullApiUrl = `${API_URL}?${queryParams.toString()}`;

    try {
        const response = await APIRequest('post', fullApiUrl, {
            action: 'getSubscription',
            token
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

